const DownloadMovie = () => {
  return (
    <section>
        <h1>Download Movie</h1>
    </section>
  )
}

export default DownloadMovie
